module.exports = __webpack_public_path__ + "static/media/sensori-logo.6462318a.png";